<div class="previous-step">
  <div translate="engagement/send-message/choose-message-template/from"></div>
  &nbsp;
  <app-site-icon-and-name [item]="chooseTemplateFlowService.taskProcessContext.site">
    <strong>{{ chooseTemplateFlowService.taskProcessContext.site['label'] }}</strong> </app-site-icon-and-name
  >&nbsp;
  <div translate="engagement/send-message/choose-message-template/to"></div>
  &nbsp;
  <strong>{{ engagementService.strategy.externalUser }}</strong>

  <ion-button (click)="back()" size="small" fill="clear">
    <span>{{ 'common/change' | translate }}</span>
  </ion-button>
</div>

<div class="choose-template-wrapper">
  <div class="editor-and-send-buttons">
    <app-message-editor-wrapper
      [control]="editorControl"
      [editorInitialContent]="editorInitialContent"
      [isEngagement]="true"
      [site]="$any(chooseTemplateFlowService.taskProcessContext.site)">
    </app-message-editor-wrapper>

    <ng-content></ng-content>
  </div>
</div>
